import React, { Component } from 'react';
import { connect } from 'react-redux';
import { setInitialPosition } from '../../actions';
import locale from '../../common/locale'
import Cookies from 'universal-cookie';

const cookies = new Cookies();

export class ForgotPasswordEmail extends Component {

  render() {
    const loc = cookies.get('locale')
    return (
      <div className='node child'
        style={{
            transform: `translate3d(
            ${this.props.client.x['l']}px,
            ${this.props.client.y['l']}px,
            0px)`,
        }}>
        <div className='content'>
          <p>{locale.after_password_email_message(loc)}</p>
        </div>
      </div>
    )
  }

  componentDidMount() {
    this.props.setInitialPosition(window.innerHeight, window.innerWidth, 'l')
  };
}

const mapStateToProps = state => ({
  client: state.client
});

const mapDispatchToProps = {
  setInitialPosition
};

export default connect(mapStateToProps, mapDispatchToProps)(ForgotPasswordEmail);



// WEBPACK FOOTER //
// ./src/components/SignupLogin/ForgotPasswordEmail.js